// require("smoothscroll-polyfill").polyfill();
// import Promise from "promise-polyfill";

// if (!window.Promise) {
//   window.Promise = Promise;
// }

//scc
import "../styles/driving_test.scss";
import "../styles/headers.scss";
import "../styles/custom.scss";

import axios from "axios";
import Utilities from "../utilities";
import Vue from "vue";

// classes
import Question from "../question";

window.Question = Question;

// setup axios
window.Utilities = Utilities;
window.axios = axios;
axios.defaults.headers.common["Accept"] = "application/json";

// small bus
export const bus = new Vue();
